export default __webpack_public_path__ + "assets/TKO-setup.137203f8.png";